var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsrael({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5184 9.39131H13.5061L12 6.78262L10.494 9.39131H7.48158L8.98786 12L7.48158 14.6087H10.494L12 17.2174L13.5061 14.6087H16.5184L15.0121 12L16.5184 9.39131ZM13.8504 12L12.9253 13.6026H11.0749L10.1496 12L11.0748 10.3974H12.9252L13.8504 12ZM12 8.79483L12.3443 9.39126H11.6558L12 8.79483ZM9.22435 10.3974H9.91304L9.56869 10.9939L9.22435 10.3974ZM9.22435 13.6026L9.56874 13.0061L9.91308 13.6026H9.22435ZM12 15.2051L11.6557 14.6087H12.3443L12 15.2051ZM14.7757 13.6026H14.087L14.4314 13.0061L14.7757 13.6026ZM14.087 10.3974H14.7757L14.4313 10.9939L14.087 10.3974Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4699 2.60869H4.53014C3.435 3.48094 2.49582 4.54041 1.76128 5.73914H22.2387C21.5041 4.54045 20.565 3.48094 19.4699 2.60869Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53014 21.3913H19.4698C20.565 20.5191 21.5041 19.4596 22.2387 18.2609H1.76128C2.49586 19.4596 3.43505 20.5191 4.53014 21.3913Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsrael);
export default __webpack_public_path__ + "static/media/israel.0aef5f92146a93d760d039e003faf1c4.svg";
export { ForwardRef as ReactComponent };